export const i18nPriceCalc = {
    packageTabLabel: {
        bg: 'Пратки',
        en: 'Packages'
    },
    palletTabLabel: {
        bg: 'Палети',
        en: 'Pallets'
    },
    freightTabLabel: {
        bg: 'Камиони',
        en: 'Freights'
    },
    relocationTabLabel: {
        bg: 'Преместване',
        en: 'Relocation'
    },
    pricingNoteText: {
        bg: 'Калкулатора автоматично преценя дали да пресметне цената в килограми или обемни килограми.',
        en: 'The calculator automatically decides how to calculate the price - by physical weight or by volume weight.'
    }
}
